import Vue, { KeepAlive } from "vue";
import VueRouter from "vue-router";
import store from "@/store";
Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/login",
  //   name: "login",
  //   component: () => import("../views/login/login.vue"),
  //   meta: {
  //     title: "登录"
  //   }
  // },
  {
    path: "/stop",
    name: "stop",
    component: () => import("../views/stop.vue"),
    meta: {
      title: "申报截止"
    }
  },
  {
    path: "/",
    redirect: "/index"
  },
  {
    path: "/login-register",
    name: "login-register",
    component: () => import("../views/login/login-register.vue"),
    meta: {
      title: "忘记密码"
    }
  },
  {
    path: "/auth-login",
    name: "auth-login",
    component: () => import("../views/login/auth-login.vue"),
    meta: {
      title: "统一身份认证登录"
    }
  },

  // {
  //   path: "/auth-login",
  //   name: "auth-login",
  //   component: () => import("../views/auth-login.vue"),
  //   meta: {
  //     title: "登录"
  //   }
  // },
  {
    path: "/", //根路径
    name: "home",
    meta: {
      title: "中关村高新技术企业认定管理"
    },
    component: () => import("../views/index.vue"), //主布局组件
    children: [
      {
        path: "index", //首页
        name: "index",
        component: () => import("../views/index/index.vue"),
        meta: {
          title: "服务事项管理平台-中关村高新技术企业认定管理"
        }
      },
      {
        path: "declare", //申报列表
        name: "declare",
        component: () => import("../views/declare/index.vue"),
        meta: {
          title: "申报列表"
        }
      },
      {
        path: "declare-desc", //  申报列表--查看
        name: "declare-desc",
        component: () => import("../views/declare/desc.vue"),
        meta: {
          title: "申报列表-查看"
        }
      },
      {
        path: "declare-add", //  申报列表--申请
        name: "declare-add",
        component: () => import("../views/declare/edit.vue"),
        meta: {
          title: "申报列表-申请"
        }
      },
      {
        path: "declare-edit", //  申报列表--编辑
        name: "declare-edit",
        component: () => import("../views/declare/edit.vue"),
        meta: {
          title: "申报列表-编辑"
        }
      },
      {
        path: "info-change", //企业信息变更
        name: "info-change",
        component: () => import("../views/info-change/index.vue"),
        meta: {
          title: "企业信息变更"
        },
        children: [
          {
            path: "name", //企业名称变更申请
            name: "name",
            component: () => import("../views/info-change/name.vue"),
            meta: {
              title: "企业名称变更申请"
            }
          },
          {
            path: "name/log", //企业名称变更记录
            name: "name/log",
            component: () => import("../views/info-change/name/log.vue"),
            meta: {
              title: "企业名称变更记录"
            }
          },
          {
            path: "name-add", //名称变更、新增
            name: "name-add",
            component: () => import("../views/info-change/name/add.vue")
          },
          {
            path: "name-desc", //名称变更查看
            name: "name-desc",
            component: () => import("../views/info-change/name/desc.vue")
          },
          {
            path: "park", //企业园区变更申请
            name: "park",
            component: () => import("../views/info-change/park.vue"),
            meta: {
              title: "企业园区变更申请"
            }
          },
          {
            path: "park/log", //企业园区变更记录
            name: "park/log",
            component: () => import("../views/info-change/park/log.vue"),
            meta: {
              title: "企业园区变更记录"
            }
          },
          {
            path: "park-add", //园区名称申请
            name: "park-add",
            component: () => import("../views/info-change/park/add.vue")
          },
          {
            path: "park-desc", //园区名称查看
            name: "park-desc",
            component: () => import("../views/info-change/park/desc.vue")
          }
        ]
      },
      {
        path: "annual-report", //年报申报
        name: "annual-report",
        component: () => import("../views/annual-report/index.vue"),
        meta: {
          title: "年报申报"
        }
      },
      {
        path: "annual-report-desc", //  年报申报--查看
        name: "annual-report-desc",
        component: () => import("../views/annual-report/desc.vue"),
        meta: {
          title: "年报申报-查看"
        }
      },
      {
        path: "annual-report-add", // 年报申报--申请
        name: "annual-report-add",
        component: () => import("../views/annual-report/add.vue"),
        meta: {
          title: "年报申报-申请"
        }
      },
      {
        path: "annual-report-edit", // 年报申报--编辑
        name: "annual-report-edit",
        component: () => import("../views/annual-report/add.vue"),
        meta: {
          title: "年报申报-编辑"
        }
      },
      {
        path: "info-mainten", //信息维护
        name: "info-mainten",
        component: () => import("../views/info-mainten/index.vue"),
        meta: {
          title: "信息维护"
        },
        children: [
          {
            path: "basic-user-info", //用户基本信息
            name: "user-info",
            component: () => import("../views/info-mainten/basic-user-info.vue"),
            meta: {
              title: "用户基本信息"
            }
          },
          {
            path: "password", //修改密码
            name: "password",
            component: () => import("../views/info-mainten/password.vue"),
            meta: {
              title: "修改密码"
            }
          },
          {
            path: "basic-info", //企业基本信息
            name: "basic-info",
            component: () => import("../views/info-mainten/basic-info.vue"),
            meta: {
              title: "企业基本信息"
            }
          },
          {
            path: "corporate-info", //企业法人信息
            name: "corporate-info",
            component: () => import("../views/info-mainten/corporate-info.vue"),
            meta: {
              title: "企业法人信息"
            }
          },
          {
            path: "head", //企业负责人及联系人信息
            name: "head",
            component: () => import("../views/info-mainten/head.vue"),
            meta: {
              title: "企业负责人及联系人信息"
            }
          },
          {
            path: "registration", //企业注册登记信息
            name: "registration",
            component: () => import("../views/info-mainten/registration.vue"),
            meta: {
              title: "企业注册登记信息"
            }
          },
          {
            path: "technology", //企业产品及技术相关信息
            name: "technology",
            component: () => import("../views/info-mainten/technology.vue"),
            meta: {
              title: "企业产品及技术相关信息"
            }
          },
          {
            path: "branch-office", //企业京外分支机构及公司信息
            name: "branch-office",
            component: () => import("../views/info-mainten/branch-office.vue"),
            meta: {
              title: "企业京外分支机构及公司信息"
            }
          },
          {
            path: "collabor-info", //企业京外合作信息
            name: "collabor-info",
            component: () => import("../views/info-mainten/collabor-info.vue"),
            meta: {
              title: "企业京外合作信息"
            }
          }
        ]
      },
      {
        path: "manage-person", //管理人员联系方式
        name: "manage-person",
        component: () => import("../views/manage-person/index.vue"),
        meta: {
          title: "管理人员联系方式"
        }
      },
      {
        path: "faq", //常见问题及解答
        name: "faq",
        component: () => import("../views/faq/index.vue"),
        meta: {
          title: "常见问题及解答"
        },
        children: [
          {
            path: "common", //常见问题
            name: "faq-common",
            component: () => import("../views/faq/common-problem.vue"),
            meta: {
              title: "常见问题"
            }
          },
          {
            path: "user", //用户手册
            name: "faq-user",
            component: () => import("../views/faq/user-manual.vue"),
            meta: {
              title: "用户手册"
            }
          },
          {
            path: "answer", //常见问题解答
            name: "faq-answer",
            component: () => import("../views/faq/answer.vue"),
            meta: {
              title: "常见问题解答"
            }
          }
        ]
      },
      {
        path: "notice", //通知公告
        name: "notice",
        component: () => import("../views/notice/index.vue"),
        meta: {
          title: "通知公告"
        }
      },
      {
        path: "notice-desc", //通知公告查看
        name: "notice-desc",
        component: () => import("../views/notice/desc.vue"),
        meta: {
          title: "通知公告-查看"
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/cgxComClient",
  routes
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (!store.getters.token && to.name !== "login" && to.name !== "login-register" && to.name !== "auth-login" && to.name !== "stop") {
    next({ name: "auth-login" });
  } else {
    next();
  }
});

export default router;
